<script>
import { mapActions } from 'vuex';
import request from '@/services/request';

export default {
    name: "modal-program-group",

    data() {
        return {
            errors: {},

            form: {
                id: "",
                program_id: "",
                name: "",
                description: "",
            }
        };
    },

    methods: {
        closeModal() {
            this.errors = {};
            this.form = {
                id: "",
                program_id: "",
                name: "",
                description: "",
            };
            this.$modal.hide("modalProgramGroup");
        },

        async saveGroup() {
            let endpoint = "/programs_groups";
            let payload = {
                program_id: this.form.program_id,
                name: this.form.name,
                description: this.form.description
            };

            if (this.form.id) {
                payload._method = "PUT";
                endpoint = `/programs_groups/${this.form.id}`;
            }

            try {
                let { data } = await request.post(endpoint, payload);

                this.successNotification(data.message);

                this.closeModal();

                // Recargar el tab de grupos
                Event.$emit("event-reload-program-relations");

            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success"
        })
    },

    created() {
        Event.$on("event-open-program-group", (group) => {
            this.errors = {};

            if (group.id) {
                // Editar
                this.form.id = group.id;
                this.form.program_id = group.program_id;
                this.form.name = group.name;
                this.form.description = group.description;
            } else {
                // Crear nuevo
                this.form.program_id = group.program_id;
            }

            this.$modal.show("modalProgramGroup");
        });
    }
};
</script>

<template>
    <modal name="modalProgramGroup" :width="'50%'" :height="'auto'" :click-to-close="false">

        <form @submit.prevent="saveGroup">
            <!-- Cerrar modal -->
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ form.id ? "Editar Grupo" : "Nuevo Grupo" }}
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <!-- Nombre -->
                    <div class="col-md-12">
                        <label>Nombre del Grupo</label>
                        <input type="text" class="form-control" v-model="form.name">
                        <div class="text-danger" v-if="errors.name">
                            {{ errors.name[0] }}
                        </div>
                    </div>

                    <!-- Descripción -->
                    <div class="col-md-12 mt-3">
                        <label>Descripción</label>
                        <textarea class="form-control" v-model="form.description" rows="3"></textarea>
                        <div class="text-danger" v-if="errors.description">
                            {{ errors.description[0] }}
                        </div>
                    </div>

                    <!-- Botones -->
                    <div class="col-12 mt-4">
                        <hr>
                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>

                        <button type="button" @click="closeModal" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Cancelar
                        </button>
                    </div>

                </div>
            </div>

        </form>

    </modal>
</template>

<style scoped>
.text-danger {
    font-size: 12px;
}
</style>
